export enum RiskIndex {
    Index1_6 = 'index_1_6',
    Index7_12 = 'index_7_12',
    Index13_19 = 'index_13_19',
    Index20_25 = 'index_20_25'
}